import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getBlock } from '../../selectors';
import MarkdownRenderer from '../MarkdownRenderer';
import Field from '../Field';

class Final extends React.Component {
  static propTypes = {
    block: PropTypes.object.isRequired,
  }

  static defaultProps = {

  }

  renderSubquestion = () => {
    return (
      <React.Fragment>
        <MarkdownRenderer source={this.props.block.get('subquestion')} />
      </React.Fragment>
    );
  }

  renderFields = () => {
    const fields = this.props.block.get('fields').map((fieldId) => {
      return (
        <Field id={fieldId} key={fieldId} />
      );
    });
    return (
      <React.Fragment>
        {fields}
      </React.Fragment>
    );
  }

  render() {
    return (
      <div className="page-block animate__animated animate__fadeIn" role="form">
        {this.renderSubquestion()}
        {this.renderFields()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const block = getBlock(state);
  return {
    block,
  };
};

export default connect(mapStateToProps)(Final);
